import React, { useEffect, useState } from 'react'
import { heroLaurels } from '../data/record'

// A few laurels fading in and out over the trailer on the home page. Only the
// ones worth showing to someone who has just arrived; the full set lives in
// the scroller further down.

const HeroLaurels = () => {
  const [i, setI] = useState(0)

  useEffect(() => {
    const t = window.setInterval(() => {
      setI((n) => (n + 1) % heroLaurels.length)
    }, 4200)
    return () => window.clearInterval(t)
  }, [])

  if (!heroLaurels.length) return null

  return (
    <div className='hero-laurels' aria-hidden='true'>
      {heroLaurels.map((l, n) => (
        <img key={l.src} src={l.src} alt='' className={n === i ? 'is-on' : ''} />
      ))}
    </div>
  )
}

export default HeroLaurels
